import { PayeeRequirement } from "@wingspanhq/wingspan-api-sdk";

import { getRequirementDefinitionTableCellProps } from "../../../../../RequirementDefinitions/utils";
import {
  CellsConfig,
  ContextItem,
  RequirementTableCallback
} from "../../../../types";
import { getRegistrationRequirementName } from "../helpers/getRegistrationRequirementName";
import { getRegistrationRequirementPayerStatusCell } from "../helpers/getRegistrationRequirementPayerStatusCell";

export const usePayerRegistrationConfig = (
  _: RequirementTableCallback
): CellsConfig<PayeeRequirement, ContextItem, undefined> => {
  return {
    isActionRequired: () => false,

    requirementName: getRegistrationRequirementName,

    toolbarActions: () => [],

    nameCell: requirement => ({
      text: getRegistrationRequirementName(requirement)
    }),

    typeCell: requirement =>
      getRequirementDefinitionTableCellProps({
        type: requirement.type!
      }),

    statusCell: getRegistrationRequirementPayerStatusCell
  };
};
